export default __webpack_public_path__ + "static/media/element_57.0ecf3994.webp";